
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/2022-tenerife-retreat",
      function () {
        return require("private-next-pages/blog/2022-tenerife-retreat.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/2022-tenerife-retreat"])
      });
    }
  